import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import './assets/styles.css'; // Update the path if it's different

createApp(App).use(router).mount('#app');
